import styled from 'styled-components';

export const FormCont = styled.div``;
export const FormHeading = styled.h3`
  font-size: 20px;
  line-height: 24px;
  font-weight: 900;
  color: #141823;
  text-transform: uppercase;
`;
export const FormSubHeading = styled.h4`
  font-size: 16px;
  line-height: 20px;
  color: #4a4a4a;
  font-weight: 400;
  margin-top: 8px;
  span {
    font-weight: 700;
  }
`;
export const FormInfo = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: #4a4a4a;
  font-weight: 400;
  margin-top: 3px;
  span {
    font-weight: 700;
  }
`;

export const FormBody = styled.div`
  padding: 40px;
`;
export const FormWrap = styled.div`
  display: flex;
  margin-top: 32px;
`;
export const FormLeft = styled.div`
  flex: 1;
`;
export const FrmRow = styled.div`
  display: flex;
  margin-bottom: 32px;
  &:last-child {
    margin-bottom: 0;
  }
`;
export const FrmColLeft = styled.div`
  width: 200px;
  flex-shrink: 0;
  margin-right: 40px;
  label {
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
    color: #333333;
  }
  p {
    font-size: 13px;
    line-height: 20px;
    font-weight: 400;
    color: #777777;
    margin-top: 3px;
  }
`;
export const FrmColRight = styled.div`
  flex: 1;
`;

export const FormRight = styled.div`
  width: 320px;
  flex-shrink: 0;
  margin-left: 40px;
`;
export const Transaction = styled.div`
  display: flex;
  justify-content: space-between;
  input {
    width: 45%;
    text-align: center;
    color: #4a4a4a;
    font-weight: bold;
    font-size: 1.4rem;
  }
`;

export const FormFooter = styled.div`
  padding: 20px 40px;
  border-top: 8px #f2f2f2 solid;
  display: flex;
  align-items: center;
  gap: 44px;
  justify-content: space-between;
  color: red;
  font-weight: bold;
`;
export const BtnSubmit = styled.button`
  display: inline-flex;
  background: #008cff;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);
  border-radius: 4px;
  padding: 14px 32px;
  outline: 0;
  border: 0;
  cursor: pointer;
  font-size: 16px;
  font-weight: 900;
  color: #fff;
  font-family: 'Lato';
  text-transform: uppercase;
  margin-left: auto;
  ${p =>
    p.disabled &&
    `
        background: #C2C2C2;
        pointer-events: none;
    `}
`;

export const CalendarWrapper = styled.div(
  props => `
    display: flex;
    position: absolute;
    @media (max-width: 768px){
      top:1.2rem;
      left: 0;
    }
  `,
);

export const CalendarWrapperFrom = styled(CalendarWrapper)(
  props => `
    //margin-left: -21rem;
    @media (max-width: 768px){
      margin-left:0;
    }
  `,
);

export const FromTimeWrap = styled.div(
  props => `
    display: flex;
    align-items: center;
    cursor: pointer;  `,
);

export const FromTimeText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: #4A4A4A;
  `,
);

export const FromTimeMainText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: #4A4A4A;
    font-weight: ${props.theme.font.fontWeight.bold};
    margin-left: ${props.theme.spacing.base};
  `,
);

export const StatementTimeWrap = styled.div(
  props => `
    display: flex;
    width: 100%;
    justify-content: flex-end;
    flex-direction: row;
    align-items: center;
  `,
);

export const StatementTimeInnerWrap = styled.div(
  props => `
    display: flex;
    width: 100%;
    border:1px #9B9B9B solid;
    border-radius: 4px;
    height: 40px;
    padding: ${props.theme.spacing.large.l12} ${props.theme.spacing.large.l20};
    @media (max-width: 768px){
      position:relative;
    }
  `,
);

export const SearchInputField = styled.div(
  props => `
        .rangeFieldWpr input,
        .singleInputWpr input {
            color: #4A4A4A;
            font-size: 16px;
            width: 100%;
            outline: none;
            border-radius: 5px;
            border: 1px #e7e7e7 solid;
            font-family: Theme.$globalFontFamily;
        }

        .singleInputWpr input::placeholder,
        .rangeFieldWpr input::placeholder {
            font-size: 16px;
            line-height: 19px;
            color: #4A4A4A;
            font-family: Theme.$globalFontFamily;
        }

        // FOR SINGLE INPUT
        .singleInputWpr {
            position: relative;
        }

        .singleInputWpr .icon {
            position: absolute;
            bottom: 16px;
            left: 12px;
        }

        .singleInputWpr input {
            padding: 12px 12px 12px 40px;
        }

        // FOR RANGE INPUT
        .rangeFieldWpr {
            display: flex;
            align-items: center;
        }

        .rangeFieldWpr input {
            padding: 12px;
        }

        .rangeFieldWpr .separator {
            display: inline-block;
            width: 8px;
            height: 3px;
            margin: 0px 8px;
            background-color: #e7e7e7;
        }

        //for promo input field
        .inputFldTwo .inputWpr {
            display: flex;
            border-radius: 4px;
        }

        .inputFldTwo .inputWpr input {
            font-family: Theme.$globalFontFamily;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            text-transform: uppercase;
            padding: 11px 12px;
            margin: 0px;
            outline: none;
            border: none;
            flex: 1;
            border-radius: 4px 0px 0px 4px;
            border: 1px solid #E4E4E4;
            border-right: none;
        }

        .inputFldTwo .inputWpr input.error {
            border: 1px solid Theme.$redBg;
            border-right: none;
        }

        .inputFldTwo .inputWpr input::placeholder {
            font-family: Theme.$globalFontFamily;
            text-transform: none;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #4A4A4A;
        }

        .inputFldTwo .inputWpr input::-webkit-input-placeholder {
            font-family: Theme.$globalFontFamily;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #4A4A4A;
        }

        .inputFldTwo .inputWpr input:-ms-input-placeholder {
            font-family: Theme.$globalFontFamily;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #4A4A4A;
        }

        .inputFldTwo .inputWpr input:focus {
            box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
            border: 1px solid transparent;
            border-right: 0;
        }

        .inputFldTwo .inputWpr input:focus+.btnWpr {
            border: 1px solid transparent;
            border-left: 0;
        }

        .inputFldTwo .inputWpr input.error:focus {
            box-shadow: none;
            border: 1px solid Theme.$redBg;
            border-right: 0px;
        }

        .inputFldTwo .inputWpr .btnWpr {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            background: Theme.$primaryColor;
            height: 44px;
            width: 44px;
            border-radius: 0 4px 4px 0;
            border: 1px solid #E4E4E4;
            border-left: none;
        }

        .inputFldTwo .inputWpr .btnWpr.error {
            border: 1px solid Theme.$redBg;
            border-left: none;
        }

        .inputFldTwo .inputWpr input.error:focus+.btnWpr {
            border: 1px solid Theme.$redBg;
            border-left: 0px;
        }

        .formInpWpr {
            position: relative;
            display: inline-block;
        }

        .formInpWpr input {
            width: 300px;
            padding-left: 12px;
            padding-right: 12px;
            display: flex;
            width: 100%;
            height: 40px;
            font-size: 14px;
            line-height: 20px;
            color: Theme.$secondaryText;
            font-family: Theme.$globalFontFamily;
            border-radius: 4px;
            border: 1px #E4E4E4 solid;
            outline: none;
        }

        .formInpWpr input::placeholder {
            font-size: 14px;
            line-height: 20px;
            color: Theme.$secondaryText;
            font-family: Theme.$globalFontFamily;
        }

        .formInpWpr .labelText,
        .formDrpFldWpr .labelText {
            margin-bottom: 8px;
            font-size: 14px;
            line-height: 16px;
            font-weight: 900;
            color: Theme.$secondaryText;
        }

        .formInpWpr.rwPgInpField {
            width: 320px;
        }

        .rwPgMiniInpField {
            width: 264px;
        }

        .formInpWpr .dropsideWpr {
            position: relative;
            display: flex;
            align-items: stretch;
        }

        .formInpWpr .dropsideWpr .formInpDropside {
            position: relative;
            display: flex;
            flex-shrink: 0;
            // align-items: center;
        }

        .formInpWpr .dropsideWpr .formInpDropside label.focus {
            border: 1px Theme.$blueText solid;
            border-right: none;
        }

        .formInpWpr .dropsideWpr .formInpDropside label {
            // display: flex;
            flex-shrink: 0;
            padding-left: 12px;
            padding-right: 14px;
            // padding-right: 12px;
            overflow: hidden;
            border: 1px #E4E4E4 solid;
            border-radius: 4px 0px 0px 4px;
            border-right: none;
            // width: 100%;
            // height: 100%;
        }

        // ---------- LITTLE CHEVRON ICON ----------
        .formInpWpr .dropsideWpr .formInpDropside::after {
            content: '';
            position: absolute;
            top: 48%;
            transform: translateY(-50%) rotate(45deg);
            right: 0px;
            width: 6px;
            height: 6px;
            pointer-events: none;
            border-right: 1px Theme.$secondaryText solid;
            border-bottom: 1px Theme.$secondaryText solid;
        }

        .formInpWpr .formInpDropside .selectInfoCtr {
            // position: absolute;
            display: flex;
            height: 100%;
            // border-right: 1px red solid;
            align-items: center;
            pointer-events: none;
        }

        .formInpWpr .formInpDropside .selectInfoCtr img {
            margin-right: 8px;
            width: 24px;
            flex-shrink: 0;
        }

        .formInpWpr .formInpFld.sd1,
        .formInpWpr .formInpFld.sd2 {
            // padding-left: 90px;
            // width: 100%;
            // flex: 1;
            // border: 1px red solid;
            border-left: none;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            width: 300px !important;
            height: 40px;
        }

        @mixin selectTagStyles {
            cursor: pointer;
            position: absolute;
            top: 0px;
            left: 0px;
            height: 100%;
            border: none;
            border-right: none;
            outline: none;
            color: transparent;
            background-color: transparent;
        }

        .formInpWpr .formInpDropside .sd1,
        .formInpWpr .formInpDropside .sd2 {
            @include selectTagStyles;
            width: 300px;
        }

        .formInpWpr .formInpDropdown {
            position: absolute;
            z-index: 10;
            width: 300px;
            top: 73px;
            left: 0px;
            border-radius: 4px;
            background-color: white;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
            overflow: scroll;
            max-height: 104px
        }

        .formInpWpr .formInpDropdown>li {
            cursor: pointer;
            display: flex;
            padding: 16px 12px;
            font-size: 12px;
            line-height: 16px;
        }

        .formInpWpr .formInpDropdown>li:first-child {
            padding-top: 24px;
        }

        .formInpWpr .formInpDropdown>li:last-child {
            padding-bottom: 24px;
        }

        .formInpWpr .formInpDropdown>li:not(:last-child) {
            border-bottom: 1px #e3e3e3 solid;
        }

        // ---------- FORM INPUT STATES ----------
        .formInpWpr input:focus {
            border: 1px Theme.$blueText solid;
        }

        .formInpWpr input.scs {
            border: 1px Theme.$darkGreenBg solid;
        }

        .formInpWpr .dropsideWpr .formInpDropside label.scs {
            border: 1px Theme.$darkGreenBg solid;
            border-right: none;
        }

        .formInpWpr .dropsideWpr .formInpDropside label.err {
            border: 1px Theme.$redBg solid;
            border-right: none;
        }

        // .formInpWpr input.scs:focus {
        //     outline: 1px Theme.$blueText solid;
        // }

        .formInpWpr input.err {
            border: 1px Theme.$redBg solid;
        }

        // .formInpWpr input.err:focus {
        //     outline: 1px Theme.$blueText solid;
        // }

        .formInpWpr .scsText {
            margin-top: 4px;
            font-size: 12px;
            line-height: 16px;
            color: Theme.$darkGreenBg;
        }

        .formInpWpr .errText {
            font-size: 12px;
            line-height: 16px;
            margin-top: 4px;
            color: Theme.$redBg;
        }

        // ---------- FOR THE DROPDOWNS ----------
        .formDrpFldWpr {
            display: flex;
            flex-direction: column;
        }

        .formDrpFld {
            display: flex;
            align-items: center;
            border-radius: 4px;
            width: max-content;
            // border: 1px #E4E4E4 solid;
        }

        .formDrpFld .formDdOptnsCtr {
            position: absolute;
            top: 51px;
            height: 150px;
            overflow-y: scroll;
            left: 0px;
            width: 100%;
            z-index: 10;
            background-color: white;
            border-radius: 4px;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
        }

        .formDrpFld .formDdOptnsCtr>li {
            padding: 8px 10px;
        }

        .formDrpFld .formDdOptnsCtr>li:hover {
            background-color: Theme.$secondaryColor;
        }

        .formDrpFld>div.active {
            border: 1px Theme.$blueText solid;
        }

        .formDrpFld>div {
            position: relative;
            cursor: pointer;
            padding: 15px 24px;
            display: flex;
            gap: 10px;
            align-items: center;
        }

        .formDrpFld>div {
            border: 1px #e4e4e4 solid;
            font-size: 14px;
            line-height: 20px;
        }

        .formDrpFld>div:first-child {
            border-radius: 4px 0px 0px 4px;
            // border-right: 1px #E4E4E4 solid;
        }

        .formDrpFld>div:last-child {
            border-radius: 0px 4px 4px 0px;
            border-right: 1px #E4E4E4 solid;
        }

        .formDrpFld>div:last-child.active {
            border: 1px Theme.$blueText solid;
        }

        // ---------- TO HIDE BUTTONS IN NUMBER INPUT TYPE ----------
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        input[type=number] {
            -moz-appearance: textfield;
        }

        .inputFieldWrapper {
            width: 300px !important;
        }

        .initialContent {
            height: 44px;
            width: 150px !important;
            color:#9d9d9d;
        }

    `,
);

export const TimePickWrapper = styled.div(
  props => `
    display: flex;
    border: 1px #9B9B9B solid;
    border-radius: 4px;
    height: 40px;
    padding: 1.2rem 2rem;

    .invDateInput {
    text-align: center;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
  }
  `,
);

export const TimeInput = () =>
  styled.div(
    props => `
        width: ${p => (p.width ? p.width : '')};
        position: relative;
        position: relative;
        input{
            width: 100%;
            background: #FFFFFF;
            border: 1px solid #9B9B9B;
            border-radius: 4px;
            outline: 0;
            height: 40px;
            font-family: 'Lato';
            font-size: 14px;
            font-weight: 400;
            color: #4A4A4A;
            padding: 0 15px;
            &:focus{
                border-color: #008CFF;
            }
        }
        ${p =>
          p.hasRupeesSymbol &&
          `
            input{
                padding: 0 15px 0 55px;
            }
        `}
        .icCalendar{
            position: absolute;
            top: 11px;
            right: 15px;
        }
    `,
  );

export const Error = styled.span`
  color: red;
  font-weight: bold;
`;

export const CloseBtn = styled.span`
  width: 24px;
  height: 24px;
  background-color: #9b9b9b;
  border-radius: 50%;
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
  &:before,
  &:after {
    position: absolute;
    left: 11px;
    content: ' ';
    height: 15px;
    width: 2px;
    margin-top: 4px;
    background-color: #fff;
  }
  &:before {
    position: absolute;
    left: 11px;
    content: ' ';
    height: 15px;
    width: 2px;
    top: 1px;
    background-color: #fff;
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
    position: absolute;
    left: 11px;
    content: ' ';
    height: 15px;
    width: 2px;
    top: 1px;
    background-color: #fff;
  }
`;
